export const tagColors = [
  "#9D7BFF",
  "#EA5B6F",
  "#6B97FD",
  "#FFBA5F",
  "#AFC55E",
  "#87DDFF",
  "#FF78B5",
  "#C64CBF",
  "#FAFA92",
  "#B69BF0",
  "#F49BAB",
  "#5070FF",
  "#E98D35",
  "#3EDD95",
  "#2BC1DF",
  "#D23D9B",
  "#FEFFC1",
  "#CA6DC1",
  "#3386FF",
  "#FD895F",
  "#88D669",
  "#17B7AC",
  "#FF8787",
  "#a142ff",
  "#FFD54F",
  "#4CAF50",
  "#2196F3",
  "#EC407A",
  "#C0392B",
  "#4DD0E1",
  "#FFB74D",
  "#90CAF9",
  "#66BB6A",
  "#FF4081",
  "#7B1FA2",
  "#FFEE58",
  "#388E3C",
  "#1976D2",
  "#F06292",
  "#E74C3C",
  "#26A69A",
  "#FF80AB",
  "#1565C0",
  "#FFD54F",
  "#2E7D32",
  "#D81B60",
  "#B39DDB",
  "#FFCA28",
  "#29B6F6",
  "#1B5E20",
  "#F48FB1",
  "#7F00FF",
  "#FFC107",
  "#00ACC1",
  "#D32F2F",
  "#FF5252",
  "#FF598A",
  "#4DD0E1",
  "#1DD1A1",
  "#55EF6B",
  "#AFEEEE",
];

let nextColorIndex = 0;

if (typeof localStorage !== "undefined") {
  try {
    const saved = localStorage.getItem("tags_next_color_index");
    if (saved !== null) nextColorIndex = Number(saved) || 0;
  } catch {}
}

export const getNextTagColor = () => {
  const color = tagColors[nextColorIndex % tagColors.length];
  nextColorIndex += 1;
  if (typeof localStorage !== "undefined") {
    try {
      localStorage.setItem("tags_next_color_index", String(nextColorIndex));
    } catch {}
  }
  return color;
};

export const resetTagColorIndex = () => {
  nextColorIndex = 0;
  if (typeof localStorage !== "undefined") {
    try {
      localStorage.removeItem("tags_next_color_index");
    } catch {}
  }
};
